<template>
    <div class="animated fadeIn">
      <b-row class="mb-3">
        <b-col sm="12 mb-3">
          <b-card header-tag="header" footer-tag="footer">
            <b-row>
              <b-col md="12">
                <div>
                  <!-- Dynamically render the tabs using v-for -->
                  <ul class="nav nav-tabs nav-justified mb-3">
                    <li class="nav-item col-3" v-for="(tab, index) in tablist[0].child" :key="index">
                      <a 
                        @click="activeTab = index" 
                        class="nav-link text-center custom-link" 
                        :class="{'active': isActiveTab(index)}">
                        <i :class="tab.icon" aria-hidden="true"></i>
                        <div>{{ tab.title }}</div>
                      </a>
                    </li>
                  </ul>
                </div>
              </b-col>
  
              <b-col md="12">
                <!-- Dynamically render the tab panels using v-if and v-for -->
                <div v-for="(tab, index) in tablist[0].child" :key="index" class="tab-panel" v-if="isActiveTab(index)">
                  <!-- Dynamically load the components based on href -->
                  <component :is="getComponentForTab(tab.href)" />
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  // Import components dynamically
  import raisedFreightAndVendorDetails from '../raisedRequestTab1/raisedFreightAndVendorDetails.vue'
  import raisedFreightAndVendorApproval from '../raisedRequestTab1/raisedFreightAndVendorApproval.vue'
  import raisedApprovalRequest from '../raisedRequestTab1/raisedApprovalRequest.vue'
  import raisedPendingRequest from '../raisedRequestTab1/raisedPendingRequest.vue'
  export default {
    data() {
      return {
        activeTab: 0, // Default active tab
        // Example dynamic tab list
        tablist: [] // This will hold the tab list dynamically
      };
    },
    components: {
      raisedFreightAndVendorDetails,
      raisedFreightAndVendorApproval,
      raisedApprovalRequest,
      raisedPendingRequest
    },
    created() {
      // Simulate fetching data from an API
      this.fetchTabList();
    },
    methods: {
      // Simulate an API call that returns a dynamic tab list
      fetchTabList() {
        // Simulate an API response with a dynamic tab list
        // this.tablist = [
        //   {
        //     href: "/raisedFreightAndVendorDetails",
        //     icon: "fa fa-truck", 
        //     title: "Raised Freight And Vendor Details",
        //     isReadonly: false
        //   },
        //   {
        //     href: "/raisedFreightAndVendorApproval",
        //     icon: "fa fa-thumbs-up", 
        //     title: "Raised Freight And Vendor Approval",
        //     isReadonly: false
        //   },
        //   {
        //     href: "/raisedApprovalRequest",
        //     icon: "fa fa-check-circle", 
        //     title: "Raised Approval Request",
        //     isReadonly: true
        //   }
        // ];
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        // this.tablist = userInfo.body[3].child
        this.tablist = userInfo.body.filter(item => item.title === 'Adhoc Requests');
      },
  
      // Method to check if the current tab is active
      isActiveTab(index) {
        return this.activeTab === index;
      },
  
      // Method to map href to the corresponding component dynamically
      getComponentForTab(href) {
        const componentsMap = {
          "/raisedFreightAndVendorDetails": raisedFreightAndVendorDetails,
          "/raisedFreightAndVendorApproval": raisedFreightAndVendorApproval,
          "/raisedApprovalRequest": raisedApprovalRequest,
          "/raisedPendingRequest": raisedPendingRequest,
        };
  
        return componentsMap[href]; // Return the component based on href
      }
    }
  };
  </script>
  
  <style scoped>
  .nav-link {
    background: #7b7b7b !important;
    width: 207.71px !important;
    height: 113px !important;
    border-radius: 20px;
    border: none;
  }
  
  .nav-link.active {
    background: #f8943f !important;
    width: 207.71px !important;
    height: 113px !important;
    border-radius: 20px;
    border: none;
  }
  
  .nav-tabs {
    border-bottom: none !important;
  }
  
  .custom-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100px; /* Optional: adjust the height based on your layout */
  }
  
  .custom-link i {
    font-size: 24px; /* Adjust icon size */
    margin-bottom: 5px; /* Add space between icon and text */
    color: #fff; /* Set icon color to white */
  }
  
  .custom-link div {
    font-size: 16px; /* Adjust text size */
    color: #fff !important;
  }
  </style>
  